/**
 * Haptic Feedback Utility
 * 
 * Provides haptic feedback for user interactions:
 * - Light feedback for selections
 * - Medium feedback for actions
 * - Heavy feedback for important actions
 * - Success/Error feedback
 */

import * as Haptics from 'expo-haptics';
import { Platform } from 'react-native';

/**
 * Light haptic feedback for selections and taps
 */
export function hapticLight() {
  if (Platform.OS === 'ios') {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
  }
}

/**
 * Medium haptic feedback for button presses and actions
 */
export function hapticMedium() {
  if (Platform.OS === 'ios') {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
  }
}

/**
 * Heavy haptic feedback for important actions
 */
export function hapticHeavy() {
  if (Platform.OS === 'ios') {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy);
  }
}

/**
 * Success haptic feedback
 */
export function hapticSuccess() {
  if (Platform.OS === 'ios') {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
  }
}

/**
 * Error haptic feedback
 */
export function hapticError() {
  if (Platform.OS === 'ios') {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Error);
  }
}

/**
 * Warning haptic feedback
 */
export function hapticWarning() {
  if (Platform.OS === 'ios') {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning);
  }
}

/**
 * Selection haptic feedback (for pickers, switches, etc.)
 */
export function hapticSelection() {
  if (Platform.OS === 'ios') {
    Haptics.selectionAsync();
  }
}

